import React from "react";
import Tooltip from "@mui/material/Tooltip";

const CButton = ({
  onClick,
  children,
  disabled,
  className,
  tooltip,
  tooltipPosition,
  mobileOnly,
  type,
  tabIndex,
}) => {
  const button = (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      tabIndex={tabIndex}
      className={`font-[Poppins] 2xl:text-base 2xl:leading-base text-sm leading-sm font-normal tracking-normal 2xl:h-[50px] md:h-[45px] h-[40px] px-4 py-2 md:rounded-[10px] rounded-[8px] transition disabled:opacity-50  cursor-pointer disabled:cursor-not-allowed inline-flex items-center justify-center gap-2 ${className}`}
    >
      {children}
    </button>
  );

  // Wrap disabled button in span for tooltip to work properly
  const buttonWithWrapper = disabled && tooltip ? (
    <span style={{ display: 'inline-flex' }}>{button}</span>
  ) : (
    button
  );

  return tooltip ? (
    <Tooltip
      title={tooltip}
      arrow
      placement={tooltipPosition} 
      className={`!text-xs !leading-xs font-semibold ${mobileOnly ? 'md:hidden' : ''}`}
      sx={{
        '& .MuiTooltip-tooltip': {
          backgroundColor: '#e5f3fa',
          fontWeight:"600"
            },
          }}
    >
      {buttonWithWrapper}
    </Tooltip>
  ) : (
    button
  );
};

export default CButton;
